var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 96H90C90 79.4575 76.5425 66 60 66C43.4575 66 30 79.4575 30 96H24C24 76.15 40.15 60 60 60C79.85 60 96 76.15 96 96Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57C50.9025 57 43.5 49.5975 43.5 40.5C43.5 31.4025 50.9025 24 60 24C69.0975 24 76.5 31.4025 76.5 40.5C76.5 49.5975 69.0975 57 60 57ZM60 30C54.21 30 49.5 34.71 49.5 40.5C49.5 46.29 54.21 51 60 51C65.79 51 70.5 46.29 70.5 40.5C70.5 34.71 65.79 30 60 30Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.440d9633.svg";
export { ForwardRef as ReactComponent };